import { useState } from "react";
import { enum_data } from "../../enum_data";

const ResumeButton = () => {
  const [status, setStatus] = useState<"idle" | "loading" | "done" | "error">(
    "idle",
  );
  const loading = status === "loading";

  const downloadResume = async () => {
    if (loading) {
      return;
    }

    setStatus("loading");

    try {
      const [{ pdf }, { default: QRCode }, { ResumePDF }] = await Promise.all([
        import("@react-pdf/renderer"),
        import("qrcode"),
        import("../ResumePDF"),
      ]);
      const qrUrl = await QRCode.toDataURL(enum_data.qrURL, {
        errorCorrectionLevel: "M",
        margin: 1,
        width: 180,
      });
      const blob = await pdf(
        <ResumePDF data={enum_data} qrUrl={qrUrl} />,
      ).toBlob();
      const blobUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");

      downloadLink.href = blobUrl;
      downloadLink.download = "Zul_Aiman_Software_Developer_Resume.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      setStatus("done");
      window.setTimeout(() => setStatus("idle"), 2200);
    } catch {
      setStatus("error");
      window.setTimeout(() => setStatus("idle"), 2200);
    } finally {
      setStatus((current) => (current === "loading" ? "idle" : current));
    }
  };

  return (
    <button
      type="button"
      className="text-link"
      data-cursor="PDF"
      onClick={downloadResume}
      disabled={loading}
      aria-live="polite"
    >
      {status === "loading"
        ? "Preparing résumé…"
        : status === "done"
          ? "Résumé downloaded"
          : status === "error"
            ? "Retry résumé"
            : "Download résumé"}
      <span aria-hidden="true">↓</span>
    </button>
  );
};

export default ResumeButton;
